/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseUser } from './BaseUser';
import { Group } from './Group';
const ExtendedGroupParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['virtualUser', BaseUser, 'virtual_user'],
]), Group);
export class ExtendedGroup extends Group {
    static decode(input) {
        return ExtendedGroupParser.decode(input).map(res => new ExtendedGroup(res));
    }
    static unsafeDecode(input) {
        return ExtendedGroup.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ExtendedGroupParser.encode(data);
    }
    static schema() {
        return ExtendedGroupParser.schema();
    }
}
